import addHours from "date-fns/addHours"
import axios from "axios"
import moment from "moment"
export const arrayToObject = (array, keyField) =>
	array.reduce((obj, item) => {
		obj[item[keyField]] = item
		return obj
	}, {})

export const objectToArray = (obj) => Object.keys(obj).map((i) => obj[i])

export const removeProperty = (obj, property) => {
	return Object.keys(obj).reduce((acc, key) => {
		if (key !== property) {
			return { ...acc, [key]: obj[key] }
		}
		return acc
	}, {})
}

export const cookieOptions = () => ({
	path: "/",
	expires: addHours(new Date(), 1),
	secure: true,
})

export const stringToBoolean = (string) => {
	if (string == null || string === "") return false

	switch (string.toLowerCase().trim()) {
		case "true":
		case "yes":
		case "1":
			return true
		case "false":
		case "no":
		case "0":
		case null:
			return false
		default:
			return Boolean(string)
	}
}

export const maskCardNumber = (cardNo) => {
	return `*** *** *** *** ${cardNo.substr(-4, 4)}`
}

export function getFieldValue(obj, path) {
	return path.split(".").reduce((p, c) => (p ? p[c] : undefined), obj)
}

export const renameRemark = (remark) => {
	switch (remark) {
		case "Mobile Ordering & Payment Purchase": {
			return "Order & Pick-up Purchase"
		}
		case "Mobile Order Rewards Redemption": {
			return "Order & Pick-up Rewards Redemption"
		}
		case "IAD Sales": {
			return "Starbucks Delivers Purchase"
		}
		case "IAD Sales with Voucher Redemption": {
			return "Starbucks Delivers Rewards Redemption"
		}
		case "GrabFood Sales": {
			return "GrabFood Purchase"
		}
		case "MOP Sales by Credit / eWallet": {
			return "Order & Pick-up Purchase"
		}
		case "MOP Sales by Credit / eWallet with Voucher Redemption": {
			return "Order & Pick-up Rewards Redemption"
		}
		case "IAD Sales by Credit / eWallet": {
			return "Starbucks Delivers Purchase"
		}
		case "IAD Sales by Credit / eWallet with Voucher Redemption": {
			return "Starbucks Delivers Rewards Redemption"
		}
		case "Voucher Bundle Card Redemption": {
			return "Voucher Bundle Purchase"
		}
		case "Voucher Bundle Sales by Credit / eWallet": {
			return "Voucher Bundle Purchase"
		}
		case "Voucher Bundle Sales": {
			return "Voucher Bundle Purchase"
		}
		default: {
			return remark
		}
	}
}

export const formatAntiFraudDate = (date) =>
	moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSZZ")

export const getClientIp = async () => {
	const res = await axios.get("https://api.ipify.org/?format=json")
	return res.data.ip
}

export const getDevicePayload = () => {
	var start = performance.now()
	var DATA_COLLECTOR_URL =
		"https://test.accdab.net/cdn/cs/HTaDglrHo2DGgUSh-84xHRxM5H4.js"
	// Data Collector script
	var s = document.createElement("script")
	s.setAttribute("type", "text/javascript")
	s.setAttribute("src", DATA_COLLECTOR_URL)
	s.setAttribute("dvct", "500")
	s.setAttribute("sid", "test-session") // set this if you have it -- UNIQUE per HTTP session if possible!
	s.setAttribute("id", "bcn")
	s.setAttribute("dvc", "l")
	s.onload = function () {
		start = performance.now()
		if (window.hasOwnProperty("_bcn") && window._bcn.hasOwnProperty("dvc")) {
			window._bcn.dvc.collect()
		}
	}
	document.head.appendChild(s)
}



// WEBPACK FOOTER //
// ./src/helpers/utility.js